import Service from "../Service";
const resource = "equipmentmaintenancetasks/";

export default {
    save(cmp, requestID) {
        return Service.post(resource + "save", cmp, {
            params: { requestID: requestID },
        });
    },
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },
    updateStatus(parameters, requestID) {
        return Service.post(resource + "updateStatus", parameters, {
            params: { requestID: requestID },
        });
    },
    saveReportMaintenance(parameters, requestID) {
        return Service.post(resource + "saveReportMaintenance", parameters, {
            params: { requestID: requestID },
        })
    },
    getReportByID(emdID, requestID) {
        return Service.get(resource + "getReportByID", {
            params: {
                EmdID: emdID,
                requestID: requestID
            }
        })
    },
    saveReprogramMaintenance(parameters, requestID) {
        return Service.post(resource + "saveReprogramMaintenance", parameters, {
            params: { requestID: requestID },
        })
    },
    getCurrentReprogramByEmdID(emdID, requestID) {
        return Service.get(resource + "getCurrentReprogramByEmdID", {
            params: {
                EmdID: emdID,
                requestID: requestID
            }
        })
    },

    DetailReport(emdID, requestID) {
        return Service.get(resource + "DetailReport", {
            params: {
                EmdID: emdID,
                requestID: requestID
            }
        })
    },

    UpdateSignature(parameters, requestID) {
        return Service.post(resource + "UpdateSignature", parameters, {
            params: { requestID: requestID },
        });
    },

    SignatureList(rptID, requestID) {
        return Service.get(resource + "SignatureList", {
            params: {
                RptID: rptID,
                UsrID: requestID,
                requestID: requestID
            }
        })
    },


};
